import { axiosInstance } from '@App/providers';
import { httpErrorResponse } from '@App/requests/shared';

export const saveAnswers = async (applicationId: string, data: any) => {
    const url = window._env_.MS_ADVICE_RECOMMENDATION_BASE_URL as string;

    try {
        const result = await axiosInstance.post(
            `${url}/v1/applications/${applicationId}/recommendations/questionnaires`,
            data,
        );
        return await { ...result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};

export const savePreferableOffer = async (
    applicationId: string,
    productCode: string,
) => {
    const url = window._env_.MS_ADVICE_RECOMMENDATION_BASE_URL as string;

    try {
        const result = await axiosInstance.post(
            `${url}/v1/applications/${applicationId}/recommendations/preferable-offers/${productCode}/select`,
        );
        return await { ...result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};
